// extracted by mini-css-extract-plugin
module.exports = {"page":"pageSwitcher_page_1q-ix"};